<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="md-grey-page">
		<div class="edit-page container margin-top-60" v-if="!companyLoaded">
			<p class="loading-text">Loading company<span>.</span><span>.</span><span>.</span></p>
		</div>

		<div class="edit-page container" v-if="companyLoaded">

		  <div class="mdc-layout-grid">
			<div class="mdc-layout-grid__inner">
			  	<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">

					  <div class="edit-page__header edit-page__info mdc-layout-grid__cell--span-3">
							<h3 class="edit-page__title">{{ company.companyDetails.companyName }}</h3>
					  </div>
				</div>

				<transition appear appear-class="slide-fade-enter" appear-active-class="slide-fade-enter-active">
				<div class="edit-page__content mdc-layout-grid__cell mdc-layout-grid__cell--span-8 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">
					<!-- Trading Name -->
					<editable-item component="editable-input" v-model="company.companyDetails.companyName" title="Company Trading Name" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateCompany" @back="getCompany"></editable-item>

					<!-- Service type -->
					<editable-item component="editable-options" v-model="company.companyDetails.serviceType" title="Service Type" :options="{items: [['Sales', 'Sales'],['Lettings', 'Lettings'], ['Both', 'Both']]}"
					@isEditView="editView(arguments[0])" @update="updateCompany" @back="getCompany"></editable-item>

					<!-- Address -->
					<editable-item component="editable-address" v-model="address" title="Address" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateCompany" @back="getCompany" @hasErrors="errors('address', arguments[0])"></editable-item>

					<!-- Email -->
					<editable-item component="editable-input" v-model="company.companyDetails.email" title="Email" :options="{placeholder: 'E-mail'}"
					@isEditView="editView(arguments[0])" @update="updateCompany" @back="getCompany" @hasErrors="errors('email', arguments[0])"></editable-item>

					<!-- Phone -->
					<editable-item component="editable-input" v-model="company.companyDetails.phone" title="Phone" :options="{placeholder: 'Phone'}"
					@isEditView="editView(arguments[0])" @update="updateCompany" @back="getCompany" @hasErrors="errors('email', arguments[0])"></editable-item>

					<!-- Logo -->
					<editable-item component="editable-image" v-model="company.companyDetails.logo" title="Logo" @isEditView="editView(arguments[0])"
					@update="updateCompany" @back="getCompany"></editable-item>

					<!-- BA Brochures -->
					<editable-item component="editable-options" v-model="company.companyDetails.baBrochures" title="BestAgent Brochures" :options="{items: [['yes', 'Yes'],['no', 'No']]}"
					@isEditView="editView(arguments[0])" @update="updateCompany" @back="getCompany"></editable-item>

					<!-- Print Marketing -->
					<editable-item v-if="isAdmin" component="editable-options" v-model="company.companyDetails.printMarketingSold" title="Automatic Just Sold Leaflets" :options="{items: [['yes', 'Yes'],['no', 'No']]}"
					@isEditView="editView(arguments[0])" @update="updateCompany" @back="getCompany"></editable-item>
					<editable-item v-if="isAdmin" component="editable-number" v-model="company.companyDetails.printMarketingSoldQuantity" title="--- Print Quantity"  :options="{min: 40, max: 500}"
					@isEditView="editView(arguments[0])" @update="updateCompany" @back="getCompany"></editable-item>
					<editable-item v-if="isAdmin" component="editable-options" v-model="company.companyDetails.printMarketingLet" title="Automatic Just Let Leaflets" :options="{items: [['yes', 'Yes'],['no', 'No']]}"
					@isEditView="editView(arguments[0])" @update="updateCompany" @back="getCompany"></editable-item>
					<editable-item v-if="isAdmin" component="editable-number" v-model="company.companyDetails.printMarketingLetQuantity" title="--- Print Quantity" :options="{min: 40, max: 500}"
					@isEditView="editView(arguments[0])" @update="updateCompany" @back="getCompany"></editable-item>

				</div>
				</transition>
			</div>
		 </div>

		</div>
</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import EditableItem 	from '../components/editable-items/EditableItem.vue';

export default {
    data: function() {
        return {
            company: {},
			allErrors: {},
			address: {
				buildingNumber: '',
				flatNumber: '',
				street: '',
				postcode: '',
				town: '',
				county: '',
				lat: 0,
				lng: 0,
				addressNotEmpty: true
			},
			companyLoaded: false
        }
    },
    mixins: [utils],
    components: {
		  'editable-item':	EditableItem
    },
	 created: function() {
	 	this.getCompany();
	 },
	 computed: {
		 isAdmin() {
 			return this.$store.getters.admin;
 		},
	 },
    methods: {
		getCompany: async function() {
		   this.company = await api({endpoint: this.config.services.companyDetails, method: 'GET'});

			this.address = this.company.companyDetails.branchAddress;
			if(!this.address.buildingNumber) {
				this.address.buildingNumber = '';
			}
			this.address.addressNotEmpty = true;

			if(!this.company.companyDetails.baBrochures) {
				this.company.companyDetails.baBrochures = 'no';
			}

			if(!this.company.companyDetails.printMarketingSold) {
				this.company.companyDetails.printMarketingSold = 'no';
				this.company.companyDetails.printMarketingSoldQuantity = 40;
				this.company.companyDetails.printMarketingLet = 'no';
				this.company.companyDetails.printMarketingLetQuantity = 40;
			}

		   this.companyLoaded = true;
	   },
		updateCompany: async function() {
			if(this.anyErrors()) {
				alert('Please fill in the missing values in order to proceed!');
				return false;
			}

			this.company.companyDetails.branchAddress.buildingNumber = this.address.buildingNumber ? this.address.buildingNumber : '';
			this.company.companyDetails.branchAddress.flatNumber = this.address.flatNumber ? this.address.flatNumber : '';
			this.company.companyDetails.branchAddress.street = this.address.street ? this.address.street.trim() : '';
			this.company.companyDetails.branchAddress.postcode = this.address.postcode ? this.address.postcode : '';
			this.company.companyDetails.branchAddress.town = this.address.town ? this.address.town.trim() : '';
			this.company.companyDetails.branchAddress.county = this.address.county ? this.address.county.trim() : '';
			this.company.companyDetails.branchAddress.latitude = this.address.latitude ? this.address.latitude : '';
			this.company.companyDetails.branchAddress.longitude = this.address.longitude ? this.address.longitude : '';

			var company = {
				companyName: this.company.companyDetails.companyName,
				branchAddress: this.address,
				serviceType: this.company.companyDetails.serviceType,
				email: this.company.companyDetails.email,
				phone: this.company.companyDetails.phone,
				logo: this.company.companyDetails.logo,
				printMarketingSold: this.company.companyDetails.printMarketingSold,
				printMarketingSoldQuantity: this.company.companyDetails.printMarketingSoldQuantity,
				printMarketingLet: this.company.companyDetails.printMarketingLet,
				printMarketingLetQuantity: this.company.companyDetails.printMarketingLetQuantity,
				baBrochures: this.company.companyDetails.baBrochures
			};

			var result = await api({endpoint: this.config.services.companies, path: '/update', method: 'POST', body: company});
		},
		errors: function(item, hasErrors) {
			this.allErrors[item] = hasErrors;
		},
		anyErrors: function() {
			var self = this;
			return Object.keys(self.allErrors).reduce(function(acc, current) {
				if(self.allErrors[current]) {
					console.log('Found error: ', current);
				}
				return acc || self.allErrors[current];
			}, false);
		}
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/CompanyEdit.vue